/**
 * @module The User Activity Tracking
 */

import {sendBeacon} from '@acng/frontend-bounty/net/beacon.js';
import {throttle} from '@acng/frontend-bounty/timing/throttle.js';
import {globalValue} from '@acng/frontend-relativity';
import {noop} from '@acng/frontend-bounty/std/value.js';

import {ctxAuthUser} from '../context/auth-user.js';

/**
 * @param {'closed_payment_page'} [activity]
 */
const track = (activity) => {
  if (!globalValue(ctxAuthUser)) {
    DEBUG: console.info('Do not track the guest.');

    return;
  }

  sendBeacon('/api/user/track-activity', activity && {activity});
};

/**
 * Track general user activity at a maximum rate of one per minute.
 */
const trackOncePerMinute = throttle(() => track(), 60000);

/**
 * Track the first closing of the payment page.
 *
 * @type {() => void}
 */
let trackClosedPaymentPage = () => {
  trackClosedPaymentPage = noop;
  track('closed_payment_page');
};

export {trackOncePerMinute, trackClosedPaymentPage};
